import { cn } from '../../lib/cn';

const SIZES = {
  sm: 'h-3.5 w-3.5 border-[1.5px]',
  md: 'h-5 w-5 border-2',
  lg: 'h-8 w-8 border-[3px]',
};

export function Spinner({ size = 'md', className }) {
  return (
    <span
      role="status"
      aria-label="Ładowanie"
      className={cn(
        'inline-block animate-spin rounded-full border-line-strong border-t-accent',
        SIZES[size],
        className
      )}
    />
  );
}

export default Spinner;
